exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2pBbY3lhB-ktJI4ZUwLYxL .content{color:dycolor-internal(!fill-success,@secondary)}\n", ""]);

// exports
exports.locals = {
	"root": "_2pBbY3lhB-ktJI4ZUwLYxL"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/fill-status-summary/FillStatusSummary.scss
// module id = 901
// module chunks = 1